import React, { Component } from "react";
import Slider from "react-slick";
import CustomNextArrow from "../../library/baaShared/CustomArrow/CustomNextArrow";
import CustomPrevArrow from "../../library/baaShared/CustomArrow/CustomPrevArrow";
import nextImage from "../../assets/black/icons-icon-arrow-left.png";
import CarouselCard from "../../library/baaShared/CarouselCard"
import "./PressCentreCarousel.scss";
import ComponentTitleSection from "../../library/baaShared/ComponentTitleSection"
import motif from "../../assets/motif.png"
import dictionary from "i18next";


class PressCentreCarousel extends Component {
  constructor(props) {
    super(props);

  }

  componentDidMount() {
    if (document.querySelector(".act-card .slick-list")) {
      document.querySelector(".act-card .slick-list").style.padding = "0";
      document.querySelectorAll('.act-card .slick-slide>div')[0].style.borderRight = "0px";
    }
    // if (window.innerWidth > 600) {
    //   document.querySelectorAll('.act-card .slick-slide')[1].style.display = "none";
    // }
  }


  render() {

    const settings = {

      className: "center",
      centerMode: true,
      infinite: true,
      centerPadding: "0px",
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      initialSlide: 1,
      nextArrow: <CustomNextArrow img={nextImage} />,
      prevArrow: <CustomPrevArrow img={nextImage} />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            // centerPadding: "50px",
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 1,
            arrows: false

          }

        },
        {
          breakpoint: 998,
          settings: {
            infinite: true,
            centerMode: true,
            // centerPadding: "50px",
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            centerMode: true,
            // centerPadding: "50px",
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: "50px",
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            arrows: false

          }
        }
      ]
    };

    const Data1 = this.props.fields["Press Releases List"]

    return (

      <React.Fragment>
        <section
          className="activity-wrapper full-width-component press-release-wrapper"
          id={this.props.rendering.componentName}
        >
          <ComponentTitleSection
            title={this.props.fields && this.props.fields.Title ? this.props.fields.Title.value : ""}
            subtitle={this.props.fields && this.props.fields.Tagline
              ? this.props.fields.Tagline.value
              : ""}
          />
          <div className="carousal-wrap act-card">
            <div className="shadow" />
            <Slider {...settings}>
              {Data1.map((data, index) => {
                return (
                  <div>
                    <CarouselCard
                      key={index}
                      src={data.fields["Hero Image"].value.src+"?h=210&w=320"}
                      alt={data.fields["Hero Image"].value.alt}
                      title={data.fields.Title.value}
                      shortDescription={data.fields.Tagline.value}
                      arrowLinkText={dictionary.t("PressReleases-View", "View")}
                      href={data.fields["CTA link"].value.href}

                    />

                  </div>
                )
              })}
              {/* {Data1.map((data, index) => {
                return (
                  <div>
                    <CarouselCard
                      key={index}
                      src={data.fields["Hero Image"].value.src+"?h=210&w=320"}
                      alt={data.fields["Hero Image"].value.alt}
                      title={data.fields.Title.value}
                      shortDescription={data.fields.Tagline.value}
                      arrowLinkText={dictionary.t("PressReleases-View", "View")}
                      href={data.fields["CTA link"].value.href}

                    />

                  </div>
                )
              })} */}
            </Slider>
            {/* <div className="motif-below" style={{ backgroundImage: `url(${motif})` }} /> */}

          </div>


        </section>
      </React.Fragment>
    );
  }
}


export default PressCentreCarousel

